import React, { useEffect, useState } from 'react';
import { Modal, Table } from 'antd';
import { j202Api, ApprovalHistory } from '../../../services/j202Api';

interface Props {
  visible: boolean;
  requestNo: string;
  onClose: () => void;
}

const actionLabels: Record<string, string> = {
  SUBMIT: '送審',
  APPROVE: '核准',
  REJECT: '退回',
};

const ApprovalHistoryModal: React.FC<Props> = ({ visible, requestNo, onClose }) => {
  const [data, setData] = useState<ApprovalHistory[]>([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (visible && requestNo) {
      setLoading(true);
      j202Api.getApprovalHistory(requestNo)
        .then(setData)
        .catch(() => setData([]))
        .finally(() => setLoading(false));
    }
  }, [visible, requestNo]);

  const columns = [
    { title: '操作', dataIndex: 'action', key: 'action', width: 80,
      render: (v: string) => actionLabels[v] || v },
    { title: '執行人', dataIndex: 'actor_name', key: 'actor_name', width: 100 },
    { title: '舊狀態', dataIndex: 'old_status', key: 'old_status', width: 70 },
    { title: '新狀態', dataIndex: 'new_status', key: 'new_status', width: 70 },
    { title: '備註', dataIndex: 'comment', key: 'comment' },
    { title: '時間', dataIndex: 'created_at', key: 'created_at', width: 160,
      render: (v: string) => v ? new Date(v).toLocaleString('zh-TW') : '' },
  ];

  return (
    <Modal
      title={`審核歷史 - ${requestNo}`}
      open={visible}
      onCancel={onClose}
      footer={null}
      width={720}
    >
      <Table
        columns={columns}
        dataSource={data}
        rowKey="id"
        size="small"
        loading={loading}
        pagination={false}
      />
    </Modal>
  );
};

export default ApprovalHistoryModal;
